import useSWR from "swr";
import {LoginResponseDto} from "../../../services/api";

export const useCheckIfAuthenticated = (shouldChangePassword: boolean | undefined) => {
    const {data, isLoading, error} = useSWR<LoginResponseDto, Error>(!shouldChangePassword ? "/api/auth/checkIfAuthenticated": null);

    return {
        data,
        isLoading,
        error
    }
}
